<div class="layout-topbar">
	<button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
		<i class="pi pi-bars"></i>
	</button>

	<!-- Injected controls slot (e.g. dispatcher search bar) -->
	<div class="layout-topbar-controls" *ngIf="topbarControlsService.template$ | async as controlsTpl">
		<ng-container [ngTemplateOutlet]="controlsTpl"></ng-container>
	</div>

	<button
		#topbarmenubutton
		class="p-link layout-topbar-menu-button layout-topbar-button"
		(click)="layoutService.showProfileSidebar()"
	>
		<i class="pi pi-ellipsis-v"></i>
	</button>

	<div
		#topbarmenu
		class="layout-topbar-menu"
		[ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }"
	>
		<div *ngIf="isAuthenticated" class="topbar-user-info">
			<p-menu #dropdown [popup]="true" [model]="dropdownItems" appendTo="body"></p-menu>
			<span>Hi, {{ loggedInUser?.firstname }} {{ loggedInUser?.lastname }}</span>
			<button class="p-link layout-topbar-button" (click)="dropdown.toggle($event)">
				<i class="pi pi-user"></i>
				<span>Profile</span>
			</button>
		</div>
		<!--DOING: replace routerLink with (click) to activate the login modal-->
		<button class="p-link layout-topbar-button" *ngIf="!isAuthenticated" routerLink="/auth/login">Log In</button>
	</div>
</div>

<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-EJ90N8K3NS"></script>
<script>
	window.dataLayer = window.dataLayer || [];
	function gtag() {
		dataLayer.push(arguments);
	}
	gtag('js', new Date());

	gtag('config', 'G-EJ90N8K3NS');
</script>
